import { twMerge } from "tailwind-merge";
import { Type, TypeVariant } from "@shared/ui/Type";

type Props = {
  title: string;
  description?: string;
  iconComponent?: React.ComponentType<{ className?: string }>;
  className?: string;
  titleTypeVariant?: TypeVariant;
};

export function AppPageHeader({
  title,
  titleTypeVariant = "h3",
  description,
  iconComponent,
  className,
}: Props) {
  const Icon = iconComponent;

  return (
    <div className={twMerge("flex flex-col gap-1", className)}>
      <Type as="h2" variant={titleTypeVariant}>
        {title}
      </Type>
      {description && (
        <div className="flex flex-row gap-2 items-start">
          {Icon && <Icon className="w-4 h-4 shrink-0 relative top-1" />}
          <Type as="p" variant="body2">
            {description}
          </Type>
        </div>
      )}
    </div>
  );
}

export default AppPageHeader;
